module.exports = __webpack_public_path__ + "img/RWBuild Summit Development Process.6fcc98a5.png";